import DOMPurify from 'dompurify';

// ReactQuill'in urettigi zengin metni dangerouslySetInnerHTML ile basmadan
// once temizler - onaylanmamis/kotu niyetli bir kullanici (ör. duyuru/KVKK
// metni olusturabilen bir sube muduru) script iceren HTML kaydedebilir,
// bu sanitize katmani olmadan o script'i goruntuleyen herkesin oturumunda
// calisirdi (stored XSS).
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || '');
